import { PublicAboutPageResponse } from "@authory-packages/core";
import { isDefaultAboutPageName } from "../types/aboutPage";

/**
 * An about page is considered "populated" once its content body is non-empty.
 */
export const aboutPageHasContent = (aboutPage: Pick<PublicAboutPageResponse, "html">) => !!aboutPage.html?.trim();

/**
 * The "This page does not have a name yet" banner only shows in the profile
 * area for populated about pages that still carry the default name.
 */
export const showAboutPageNoNameBanner = (aboutPage: Pick<PublicAboutPageResponse, "html" | "name">) =>
    aboutPageHasContent(aboutPage) && isDefaultAboutPageName(aboutPage.name);
